export default __webpack_public_path__ + "static/media/management-sale-items.82d56323.png";